import { envs } from '../redux/api/windowServerData'

export const loadCookieConsentScripts = () => {
    // Função para verificar se as variáveis de ambiente necessárias estão disponíveis
    const areEnvsReady = () => {
        return envs &&
            typeof envs === 'object' &&
            envs.REACT_APP_COOKIES &&
            envs.REACT_APP_COOKIES.trim() !== '' &&
            envs.REACT_APP_COOKIES !== 'false' &&
            envs.REACT_APP_COOKIES_AUTO_BLOCK &&
            envs.REACT_APP_COOKIES_SDKS &&
            envs.REACT_APP_COOKIES_DOMAIN
    }

    // Função para carregar os scripts
    const loadScripts = () => {
        if (!areEnvsReady()) {
            return
        }

        const scripts = [
            {
                src: envs.REACT_APP_COOKIES_AUTO_BLOCK,
                type: 'text/javascript',
            },
            {
                src: envs.REACT_APP_COOKIES_SDKS,
                type: 'text/javascript',
                charset: 'UTF-8',
                'data-domain-script': envs.REACT_APP_COOKIES_DOMAIN,
            },
        ]

        // Verifica se todos os scripts têm os valores necessários
        const hasAllScriptValues = scripts.every(script =>
            Object.values(script).every(value => value !== undefined && value !== '')
        )

        if (!hasAllScriptValues) {
            return
        }

        // Carrega os scripts
        scripts.forEach((scriptInfo) => {
            const script = document.createElement('script')
            Object.entries(scriptInfo).forEach(([key, value]) => {
                script.setAttribute(key, value)
            })
            document.head.appendChild(script)
        })

        // Adiciona o script do OptanonWrapper
        const optanonWrapperScript = document.createElement('script')
        optanonWrapperScript.type = 'text/javascript'
        optanonWrapperScript.innerHTML = 'function OptanonWrapper() {}'
        document.head.appendChild(optanonWrapperScript)
    }

    // Tenta carregar imediatamente se as variáveis já estiverem disponíveis
    if (areEnvsReady()) {
        loadScripts()
        return
    }

    // Se não estiverem prontas, aguarda o evento de carregamento do DOM
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            // Aguarda um pequeno delay para garantir que as variáveis de ambiente foram carregadas
            setTimeout(() => {
                if (areEnvsReady()) {
                    loadScripts()
                } else {
                    // Se ainda não estiverem prontas, tenta novamente após um intervalo
                    const interval = setInterval(() => {
                        if (areEnvsReady()) {
                            loadScripts()
                            clearInterval(interval)
                        }
                    }, 100)

                    // Limpa o intervalo após 5 segundos para evitar loop infinito
                    setTimeout(() => clearInterval(interval), 5000)
                }
            }, 100)
        })
    } else {
        // Se o DOM já estiver carregado, tenta carregar imediatamente
        if (areEnvsReady()) {
            loadScripts()
        } else {
            // Se não estiverem prontas, tenta novamente após um intervalo
            const interval = setInterval(() => {
                if (areEnvsReady()) {
                    loadScripts()
                    clearInterval(interval)
                }
            }, 100)

            // Limpa o intervalo após 5 segundos para evitar loop infinito
            setTimeout(() => clearInterval(interval), 5000)
        }
    }
}
